import { PUT_ENTERPRISES_START } from '../../types';

export const put_enterprises = (payload) => ({
  type: PUT_ENTERPRISES_START,
  payload,
});
